import { canRecord } from "./mime-types";

export type Mp4Capability = {
  direct: boolean;
  fallbackMessage: string;
};

export function getMp4Capability(): Mp4Capability {
  const direct = canRecord("mp4");
  return {
    direct,
    fallbackMessage: direct
      ? "このブラウザではMP4を直接録画できます。"
      : "このブラウザではMP4の直接録画に対応していません。WebMを書き出してください。"
  };
}
